/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { renownUserProfileActions } from "./gen/creators.js";

/** Actions for the RenownUser document model */

export const actions = { ...baseActions, ...renownUserProfileActions };
